import { render, staticRenderFns } from "./ContainerFile.vue?vue&type=template&id=88ed5ac6&lang=pug"
import script from "./ContainerFile.vue?vue&type=script&lang=js"
export * from "./ContainerFile.vue?vue&type=script&lang=js"
import style0 from "./ContainerFile.vue?vue&type=style&index=0&id=88ed5ac6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports